// Generated by psc version 0.10.2
"use strict";
var $foreign = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-integers/src/Data/Int/Bits.js");
module.exports = {
    and: $foreign.and, 
    complement: $foreign.complement, 
    or: $foreign.or, 
    shl: $foreign.shl, 
    shr: $foreign.shr, 
    xor: $foreign.xor, 
    zshr: $foreign.zshr
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-integers/src/Data/Int/Bits.purs
// module id = 101
// module chunks = 0